export const MapFeatures = (map) => {
  const preservedSources = {};
  const preservedlayers = [];

  map.getStyle().layers.forEach((layer) => {
    if (layer.id.endsWith("-layerl") || layer.id.startsWith("dynamic-") || layer.id === "haloRegionLayer") {
      preservedlayers.push(layer);
    }
  });

  for (const sourceId in map.getStyle().sources) {
    if (sourceId.endsWith("-sourcel") || sourceId.startsWith("dynamic-") || sourceId === "haloRegion") {
      preservedSources[sourceId] = map.getStyle().sources[sourceId];
    }
  }
  return { preservedSources, preservedlayers };
};

export const applyMapFeatures = (map, data) => {
  const { preservedSources, preservedlayers } = data;
  map.once("styledata", () => {
    for (const [sourceId, sourceData] of Object.entries(preservedSources)) {
      if (!map.getSource(sourceId)) {
        map.addSource(sourceId, sourceData);
      }
    }

    for (const layer of preservedlayers) {
      if (!map.getLayer(layer.id)) {
        map.addLayer(layer);
      }
    }
  });
};

export const addButtons = (map, terrainId, satelliteId, mapboxOwner) => {
  const layers = [
    { id: terrainId, name: "Terrain" },
    { id: satelliteId, name: "Satellite" },
  ];
  const layerMenu = document.createElement("div");
  layerMenu.className =
    "mapboxgl-ctrl-group-val mapboxgl-ctrl horizontal-buttons-val";
  layers.forEach((layer) => {
    const button = document.createElement("button");
    button.textContent = layer.name;
    button.className = layer.id === terrainId ? "active" : "";
    button.onclick = () => {
      const data = MapFeatures(map);
      map?.setStyle(`mapbox://styles/${mapboxOwner}/` + layer.id);
      document
        .querySelectorAll(".horizontal-buttons-val button")
        .forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");
      applyMapFeatures(map, data);
    };
    layerMenu.appendChild(button);
  });
  map?.addControl({
    onAdd: function () {
      return layerMenu;
    },
    onRemove: function () {
      layerMenu.parentNode.removeChild(layerMenu);
    },
  });
};

export const addDesignedButtons = (map, terrainId, satelliteId, mapboxOwner, AddCircleToMap) => {
  const layers = [
    { id: terrainId, name: "Terrain" },
    { id: satelliteId, name: "Satellite" },
  ];
  const layerMenu = document.createElement("div");
  layerMenu.className = "ats-mapbox-map-type-switch";
  layers.forEach((layer) => {
    const button = document.createElement("button");
    button.textContent = layer.name;
    button.className = layer.id === terrainId ? "active" : "";
    button.onclick = () => {
      const currentCenter = map.getCenter();
      const currentZoom = map.getZoom();
      map.setStyle(`mapbox://styles/${mapboxOwner}/` + layer.id);
      document
        .querySelectorAll(".ats-mapbox-map-type-switch button")
        .forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      map.once('style.load', () => {
        map.setCenter(currentCenter);
        map.setZoom(currentZoom);
        AddCircleToMap();
      });
    };
    layerMenu.appendChild(button);
  });
  map.addControl({
    onAdd: function () {
      return layerMenu;
    },
    onRemove: function () {
      layerMenu.parentNode.removeChild(layerMenu);
    },
  }, "top-left");
};
